var _defs, _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchiveChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.b,.c{stroke:#0d0d0d;stroke-linejoin:round;stroke-width:1.5px;}.b{stroke-linecap:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M80,152v9.968a1.562,1.562,0,0,0,1.557,1.557H92.148a1.562,1.562,0,0,0,1.557-1.557V152",
    transform: "translate(-77.853 -146.991)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 16.198,
    height: 3.29,
    rx: 1.645,
    transform: "translate(0.901 1.466)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M196.984,226.492,194.492,224,192,226.492m2.492-1.631v4.746",
    transform: "translate(-185.492 -216.187)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveChatIcon);
export default __webpack_public_path__ + "static/media/unarchive-chat-icon.facda6b2db31a578fabe3c3746221c72.svg";
export { ForwardRef as ReactComponent };